import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './LoginForm';
import { AuthUserApi, GuestApi } from '../../../utils/api';
import useForm from '../../../useForm';
import validate from '../../../validate/validateUserLogin';
import { toast } from 'react-toastify';
import GuestLayout from '../../../Layout/GuestLayout';
import { getBrowserToken } from '../../../utils/firebase';
import { useTranslation } from '../../../Context/LanguageContext';

const Login = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formInputObj = {
    email: '',
    password: '',
    role: '',
  };

  const sendTokenToServer = async (browserToken, accessToken) => {
    try {
      const requestBody = {
        fcm_token: browserToken,
      };
      const config = {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      };
      const saveDeviceTokenResponse = await AuthUserApi.post(
        '/user/register-device',
        requestBody,
        config,
      );
      const { status, data } = saveDeviceTokenResponse;
      if (status === 200) {
        return;
      } else {
        console.log(saveDeviceTokenResponse);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  const submit = async () => {
    setIsLoading(true);
    try {
      var saveResponse = await GuestApi.post('/user/login', values);
      const { status, data } = saveResponse;

      if (status === 200 && data.token !== undefined) {
        localStorage.setItem('user_data', `${JSON.stringify(data)}`);
        setValues({ ...formInputObj });

        const permisssionResult = Notification.permission;
        if (permisssionResult === 'granted') {
          const browserToken = await getBrowserToken();
          await sendTokenToServer(browserToken, data.token.access_token);
        } else {
          // Request for permission
          const notificationPermissionResult =
            await Notification.requestPermission();
          if (notificationPermissionResult === 'granted') {
            const browserToken = await getBrowserToken();
            await sendTokenToServer(browserToken, data.token.access_token);
          }
        }

        toast.success(t('loginSuccess'));
        navigate('/dashboard');

        window.location.reload();
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
      const { response } = e;
      if (
        response !== undefined &&
        Object.keys(response.data).length &&
        response.data.error !== undefined
      ) {
        setErrors(response.data.error); // if error from server side
      }
    } finally {
      setIsLoading(false);
    }
  };

  const { handleChange, handleSubmit, values, errors, setErrors, setValues } =
    useForm(submit, validate, formInputObj);

  return (
    <>
      <GuestLayout
        Title={t('attentionTitle')}
        Subtitle={t('attentionSubtitle')}
        FormTitle={t('signIn')}
        FormSubTitle={t('signInSubtitle')}
      >
        <LoginForm
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          setValues={setValues}
          values={values}
          errors={errors}
          isLoading={isLoading}
        />
      </GuestLayout>
    </>
  );
};

export default Login;
